// extracted by mini-css-extract-plugin
export default {"cls1":"PaperLinkElement-cls1__a3aad22bb02a582ec54a","cls2":"PaperLinkElement-cls2___621ce83375cdd57c776 PaperLinkElement-cls1__a3aad22bb02a582ec54a"};